import { createContract, retrieve } from '@exonet/jsonapi-fetcher/lib/resources';

const UC_RELATIONS = [
  'user',
  'roles',
  'email_addresses',
  'phone_numbers',
  'primary_email_address',
  'primary_phone_number',
];

export default {
  onMount: (store, { userId }) => {
    if (!userId) return Promise.resolve();

    const customerId = store.state?.app?.customer?.id;
    const contract = customerId
      ? createContract('user_customers').filter('user', userId).filter('customer', customerId)
      : createContract('user_customers').filter('user', userId);

    return retrieve(contract, store).with(UC_RELATIONS).get();
  },
};
